import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  return <Section id="testimonials" background="white" data-id="element-172">
      <div className="max-w-4xl mx-auto text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mb-8 flex justify-center" data-id="element-174">
          <div className="w-12 h-12 bg-[#00316B]/10 rounded-full flex items-center justify-center text-[#00316B]" data-id="element-175">
            <Quote size={24} data-id="element-176" />
          </div>
        </motion.div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-2xl md:text-3xl font-heading font-medium text-[#0C0C0C] leading-tight mb-8" data-id="element-177">
          "Working with the team was seamless. They understood our vision
          quickly and delivered a product that feels both modern and highly
          functional."
        </motion.blockquote>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-178">
          <div className="font-bold text-[#0C0C0C]" data-id="element-179">Sarah Jenkins</div>
          <div className="text-sm text-gray-500" data-id="element-180">CTO, Nexus Digital</div>
        </motion.div>
      </div>
    </Section>;
}